export default "__VITE_ASSET__oveaVyJI__"